import React from 'react';
import './Partners.css';

export default function Partner() {
  return (
    <div id="v3-strict-scope" className="partner-section">

      {/* Header Area */}
      <div className="partner-header">
        <span className="partner-label">PARTNERS</span>
        <h2 className="partner-title">
          Our <span className="highlight-text">trusted</span> lending partners
        </h2>
      </div>

      {/* 4x2 Logo Grid (8 Lenders) */}
      <div className="partner-grid">
        {/* Row 1 */}
        <div className="partner-logo-cell border-right border-bottom">
          <img src="/assets/bank_img/logo/MuthootFinanceGL.png" alt="Muthoot Finance" />
        </div>
        <div className="partner-logo-cell border-right border-bottom">
          <img src="/assets/img/image 33.svg" alt="IIFL Finance" />
        </div>
        <div className="partner-logo-cell border-right border-bottom">
          <img src="/assets/bank_img/logo/ShriramFinanceGL.png" alt="Shriram Finance" />
        </div>
        <div className="partner-logo-cell border-bottom">
          <img src="/assets/bank_img/logo/ManipalFintechGL.png" alt="Manipal Fintech" />
        </div>

        {/* Row 2 */}
        <div className="partner-logo-cell border-right">
          <img src="/assets/bank_img/logo/CapriLoansGL.png" alt="Capri Global" />
        </div>
        <div className="partner-logo-cell border-right">
          <img src="/assets/bank_img/logo/MuthootFincorpGL.png" alt="Muthoot Fincorp" />
        </div>
        <div className="partner-logo-cell border-right">
          <img src="/assets/bank_img/logo/OromoneyGL.png" alt="Oro Money" />
        </div>
        <div className="partner-logo-cell">
          <img src="/assets/bank_img/logo/RupeekGL.png" alt="Rupeek GL" />
        </div>
      </div>

      {/* --- Benefit Cards Section --- */}
      <div className="partner-benefits">

        {/* Card 1: RBI Regulated */}
        <div className="benefit-card">
          <div className="benefit-icon">
            <img src="/assets/img/Protect.png" alt="Protect Shield" />
          </div>
          <div className="benefit-text">
            <h3>RBI-regulated lenders</h3>
            <p>All lending partners operate under Reserve Bank of India guidelines.</p>
          </div>
        </div>

        {/* Card 2: Transparent terms */}
        <div className="benefit-card">
          <div className="benefit-icon">
            <img src="/assets/img/File-display-one.png" alt="Document File" />
          </div>
          <div className="benefit-text">
            <h3>Transparent loan terms</h3>
            <p>Clear rates, no hidden charges. Know what you're agreeing to.</p>
          </div>
        </div>

        {/* Card 3: Gold kept secure */}
        <div className="benefit-card">
          <div className="benefit-icon">
            <img src="/assets/img/Lockk.png" alt="Security Lock" />
          </div>
          <div className="benefit-text">
            <h3>Your gold kept secure</h3>
            <p>Gold is stored in certified vaults by your chosen lending partner.</p>
          </div>
        </div>

      </div>
    </div>
  );
}